import logo from '../../logo/utd-logo.png';
import NavBar from '../NavBar/NavBar';
import Admissions from '../Admissions/Admissions';

function Home() {
    return (
      <>
        <img className="w-full md:w-2/3 xl:w-1/3" src={logo} alt="logo" />
        <NavBar/>
        <Admissions/>
      </>
    );
  }
  
  export default Home;

